import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};

@Injectable()
export class EditThirdService {

    static ENV = environment;
    constructor( private httpService: HttpService) {
    }

    public consultThird(data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.post(EditThirdService.ENV.environment.API.consult_third, data, httpRequesthandler);
    }

    public editThird(data: any, httpRequesthandler: HttpRequestHandler): void {
        httpRequesthandler.headers = HEADERS;
        this.httpService.post(EditThirdService.ENV.environment.API.edit_third, data, httpRequesthandler);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/third-party/edit-third.service.ts